import type { DeleteMeResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { createMutation } from '~/shared/api'

/**
 * DELETE /users/me — реальное каскадное удаление аккаунта + тихий разрыв всех связей
 * (спека 07 §3, п.5). Подтверждается `ConfirmSheet` на экране приватности, успех закрывает
 * Mini App (`platform.close()` в `DeleteSection`).
 */
export const DeleteAccountMutation = createMutation<void, DeleteMeResponse, void>({
  key: 'user.deleteAccount',
  path: API_PATHS.user.me,
  method: 'DELETE',
  transform: () => undefined,
})
